import { render, staticRenderFns } from "./dietProcess-dialog.vue?vue&type=template&id=7b1b06f5&scoped=true"
import script from "./dietProcess-dialog.vue?vue&type=script&lang=js"
export * from "./dietProcess-dialog.vue?vue&type=script&lang=js"
import style0 from "./dietProcess-dialog.vue?vue&type=style&index=0&id=7b1b06f5&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1b06f5",
  null
  
)

export default component.exports